import './toast.scss';
import { $alert } from 'app/shared/angular_imports';

/**
 * @ngdoc service
 * @name ims.shared.service:Toast
 * @description
 * This service handles the creation, management and removal of a toast that is used for notifications.
 * To use, create a new instance of the service.
 *
 */

export class Toast {
    private toast: any;
    static get SUCCESS(): string {
        return 'success';
    }

    static get WARNING(): string {
        return 'warning';
    }

    static get INFO(): string {
        return 'info';
    }

    static get ERROR(): string {
        return 'error';
    }

    static get FOREVER(): boolean {
        return false;
    }

    static get LONG(): number {
        return 18;
    }

    static get MEDIUM(): number {
        return 7;
    }

    static get SHORT(): number {
        return 3;
    }

    hide(): void {
        this.toast.hide();
    }
    constructor(
        type: string,
        promptText: string | undefined = undefined,
        promptTitle: string | undefined = undefined,
        duration: number | boolean = Toast.SHORT,
        onClick = undefined,
        onHide = () => {},
        triggerId?: number,
    ) {
        this.toast = $alert({
            title: promptTitle,
            content: promptText,
            duration: duration,
            container: '#alert-toast-container',
            type: type,
            animation: false,
            show: true,
            onBeforeHide: (e) => {
                e.$element.addClass('fading');
                onHide();
            },
            controllerAs: '$ctrl',
            controller: function () {
                'ngInject';
                const ctrl = this;
                ctrl.triggerId = triggerId || -1;
                if (onClick) {
                    ctrl.clickable = true;
                    ctrl.onClick = onClick;
                }
            },
            template: `
                <div
                    data-toast-trigger-id="{{$ctrl.triggerId}}"
                    class="alert"
                    ng-class="[type ? 'alert-' + type : null, $ctrl.clickable ? 'clickable' : null]"
                    ng-click="$ctrl.clickable && $ctrl.onClick()">
                    <button
                        type="button"
                        class="close"
                        ng-if="dismissable"
                        ng-click="$hide()">
                            &times;
                    </button>
                    <span ng-if="title">
                        <strong ng-bind="title"></strong>
                        <span ng-bind-html="content"></span>
                    </span>
                    <span
                        ng-if="!title"
                        ng-bind-html="content">
                    </span>
                </div>
            `,
        });
    }
}
